import api from '../services/ApiService';

export default {
    namespaced: true,
    state: {
        isPlaying: false,
        post: null
    },
    getters: {
        isPlaying(state){
           return state.isPlaying;
        },
        post(state){
            return state.post;
        }
    },
    mutations: {
        setPlay(state){
            state.isPlaying = true;
        },
        setPause(state){
            state.isPlaying = false;
        },
        setPost(state, post){
            state.post = post;
        }

    }
}


// WEBPACK FOOTER //
// ./src/store/player.js